import { StateAcronym } from "../state/state-acronym";
import { PractitionerSpecialty } from "./practitioner-specialty";
import { PractitionerStatus } from "./practitioner-status";

export class Practitioner {
  private key: string;
  private name: string;
  private stateAcronym: StateAcronym;
  private registration: string;
  private status: PractitionerStatus;
  private specialties: PractitionerSpecialty[];

  constructor() {
    this.specialties = [];
  }

  public getKey(): string {
    return this.key;
  }

  public setKey(value: string): void {
    this.key = value;
  }

  public getName(): string {
    return this.name;
  }

  public setName(value: string): void {
    this.name = value;
  }

  public getStateAcronym(): StateAcronym {
    return this.stateAcronym;
  }

  public setStateAcronym(value: StateAcronym): void {
    this.stateAcronym = value;
  }

  public getRegistration(): string {
    return this.registration;
  }

  public setRegistration(value: string): void {
    this.registration = value;
  }

  public getStatus(): PractitionerStatus {
    return this.status;
  }

  public setStatus(value: PractitionerStatus): void {
    this.status = value;
  }

  public getSpecialties(): PractitionerSpecialty[] {
    return this.specialties;
  }

  public setSpecialties(value: PractitionerSpecialty[]): void {
    this.specialties = value;
  }

  public getSpecialtiesSearchView(): string {
    if (this.specialties.length === 0) return "-";
    return this.specialties[0].getDescription();
  }

  public hasMoreThanOneSpecialty(): boolean {
    return this.specialties.length > 1;
  }

  public getSpecialtyCountView(): string {
    return `+${this.specialties.length - 1}`;
  }
}
